import { Percent, Truck, UserCheck, FileText } from "lucide-react";
import { toast } from "sonner";

const Field = ({ label, testId, textarea, ...props }) => (
  <label className="block">
    <span className="text-sm font-semibold mb-1 block">{label}</span>
    {textarea ? (
      <textarea {...props} data-testid={testId} rows={4}
        className="w-full px-3 py-2 rounded-md border border-[#E2E2E2] text-sm focus:outline-none focus:ring-2 focus:ring-[#111111]" />
    ) : (
      <input {...props} data-testid={testId}
        className="w-full h-10 px-3 rounded-md border border-[#E2E2E2] text-sm focus:outline-none focus:ring-2 focus:ring-[#111111]" />
    )}
  </label>
);

export default function WholesalePage() {
  const submit = (e) => {
    e.preventDefault();
    toast.success("Pieteikums nosūtīts!", { description: "Mūsu menedžeris sazināsies ar tevi 1 darba dienas laikā." });
    e.target.reset();
  };

  return (
    <div className="max-w-7xl mx-auto px-4 mt-6">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight uppercase mb-2" data-testid="wholesale-page-title">Vairumtirdzniecība</h1>
      <p className="text-sm text-[#6B6B6B] mb-8 max-w-2xl">Īpaši nosacījumi uzkopšanas uzņēmumiem, HoReCa, birojiem, skolām, iestādēm un ražotnēm.</p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div className="space-y-4">
          {[
            { icon: Percent, t: "Vairumtirdzniecības cenas", d: "Individuālas atlaides atkarībā no apjoma — līdz pat 30% no mazumcenas. Cenas ar un bez PVN rēķinos." },
            { icon: Truck, t: "Regulāra piegāde", d: "Piegāde pēc grafika visā Latvijā ar mūsu transportu. Bezmaksas piegāde pastāvīgajiem klientiem." },
            { icon: UserCheck, t: "Personīgais menedžeris", d: "Viens kontakts visiem jautājumiem — pasūtījumi, rēķini, preču ieteikumi un aizvietotāji." },
            { icon: FileText, t: "Apmaksa ar rēķinu", d: "Pēcapmaksa 7–30 dienas juridiskām personām ar līgumu." },
          ].map((x) => (
            <div key={x.t} className="flex gap-4 items-start bg-[#F5F5F5] rounded-md p-5">
              <span className="w-11 h-11 rounded-md bg-[#111111] flex items-center justify-center shrink-0"><x.icon size={20} className="text-white" /></span>
              <div>
                <div className="font-bold">{x.t}</div>
                <div className="text-sm text-[#6B6B6B] mt-1">{x.d}</div>
              </div>
            </div>
          ))}
        </div>
        <form onSubmit={submit} className="bg-white border border-[#E2E2E2] rounded-md p-6 space-y-4 h-fit" data-testid="wholesale-form">
          <h2 className="text-lg font-bold">Pieteikties sadarbībai</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Uzņēmuma nosaukums *" required testId="wholesale-company" />
            <Field label="Reģ. nr. *" required testId="wholesale-reg-nr" />
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Kontaktpersona *" required testId="wholesale-contact" />
            <Field label="Tālrunis *" required type="tel" testId="wholesale-phone" />
          </div>
          <Field label="E-pasts *" required type="email" testId="wholesale-email" />
          <Field label="Kādas preces jūs interesē?" textarea testId="wholesale-message" placeholder="Piem., tīrīšanas ķīmija birojam ~50 darbiniekiem, ikmēneša piegāde…" />
          <button type="submit" data-testid="wholesale-submit" className="w-full bg-[#D0121A] hover:bg-[#A80D14] text-white font-bold py-3.5 rounded-md transition-colors">Nosūtīt pieteikumu</button>
        </form>
      </div>
    </div>
  );
}
